export default class ApprovalActions {

    static NEW_DATA = 'NEW_DATA';
    static UPDATE_DATA='UPDATE_DATA';
    static SHOW_DATA='SHOW_DATA';
    static VIEW_DATA='VIEW_DATA';
    static DELETE_DATA='DELETE_DATA';
    static ON_SUBMIT='ON_SUBMIT';
    static ERROR_DATA='ERROR_DATA';
    static PROCESS_DATA='PROCESS_DATA';
    static RESET_DATA='RESET_DATA';
    static SUCCESS_DATA='SUCCESS_DATA';
    static ERROR_SERVER='ERROR_SERVER';
    static RESET_LIST='RESET_LIST';
    static GET_HELPER='GET_HELPER';
  
    static submit(){
      return {
        type: ApprovalActions.ON_SUBMIT
      };
    }
  
    static create(data) {
      return {
        type: ApprovalActions.NEW_DATA,
        payload: data
      };
    }
  
    static update(data) {
      return {
        type: ApprovalActions.UPDATE_DATA,
        payload: data
      };
    }
  
    static view(data) {
      return {
        type: ApprovalActions.VIEW_DATA,
        payload: data
      };
    }
  
    static delete(data) {
      return {
        type: ApprovalActions.DELETE_DATA
      };
    }
  
    static list(data) {
      return {
        type: ApprovalActions.SHOW_DATA,
        payload: data
      };
    }
    static resetList() {
      return {
        type: ApprovalActions.RESET_LIST
      };
    }
    static error(error){
      return {
        type: ApprovalActions.ERROR_DATA,
        payload: error
      };
    }
    static success(data){
      return {
        type: ApprovalActions.SUCCESS_DATA,
        payload: data
      };
    }
    static process(){
      return {
        type: ApprovalActions.PROCESS_DATA,
      };
    }
    static reset(){
      return {
        type: ApprovalActions.RESET_DATA,
      };
    }
    static errorInternal(error){
      return {
        type: ApprovalActions.ERROR_SERVER,
        payload: error
      };
    }
    static helper(data){
        return {
          type: ApprovalActions.GET_HELPER,
          payload: data
        };
      }
  }
  
  